module.exports = __webpack_public_path__ + "img/feature-admob.34631446.png";